export enum GameState {
  Stop = 0,
  Play = 1,
  Pause = 2,
  Finish = 3
};

export enum Color {
  Brick = 'black',
  Figure = 'orange'
};

export enum FigureName {
  Gun = 0,
  Flug = 1,
  Duck = 2,
  Leg = 3,
  Post = 4,
  Stick = 5,
  Snake = 6,
  Hump = 7,
  Wall = 8,
  Pyramid = 9,
  Nose = 10,
  Table = 11,
  Lover = 12,
};

export enum Action {
  Play = 13,
  Right = 39,
  Left = 37,
  Down = 40,
  Rotate = 38,
};
